const request = async (url: string, options: any) => {
  try {
    const res = await fetch(url, options);
    return res.json();
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getGermanMarket = async () => {
  const url = `https://storage.googleapis.com/psylaris-assets/Catalogs/catalog_2.0.0_germany.json`;
  return request(url, { method: 'GET' });
};

const getNetherlandsMarket = async () => {
  const url = `https://storage.googleapis.com/psylaris-assets/Catalogs/catalog_2.0.0_netherlands.json`;
  return request(url, { method: 'GET' });
};

const MarketRequests = {
  getGermanMarket,
  getNetherlandsMarket,
};

export default MarketRequests;
